import { useMemo } from 'react'

const useConditionalData = (data, conditions = {}) => {
  return useMemo(() => {
    const result = {}
    
    Object.entries(conditions).forEach(([key, condition]) => {
      if (typeof condition === 'function') {
        result[key] = condition(data)
      } else if (typeof condition === 'string') {
        result[key] = !!data?.[condition]?.length
      } else {
        result[key] = !!data?.[key]?.length
      }
    })
    
    return result
  }, [data, conditions])
}

export default useConditionalData
